// Enum values and prop keys are sent verbatim to Mixpanel — never rename them.

export enum CancelSurveySubscriptionType {
  Trial = 'trial',
  Paid = 'paid',
}

export enum CancelSurveyReasonCode {
  TooExpensive = 'too_expensive',
  MissingFeature = 'missing_feature',
  NotUsing = 'not_using',
  TooComplex = 'too_complex',
  TechnicalIssue = 'technical_issue',
  Switched = 'switched',
  GoalReached = 'goal_reached',
  JustTrying = 'just_trying',
  NoTime = 'no_time',
  NotWorthYet = 'not_worth_yet',
  Privacy = 'privacy',
  DuplicateAccount = 'duplicate_account',
  Other = 'other',
}

export enum CancelSurveyDetailCode {
  FeatIcal = 'feat_ical',
  FeatProjects = 'feat_projects',
  FeatRecurring = 'feat_recurring',
  FeatNotes = 'feat_notes',
  FeatTimeTracking = 'feat_time_tracking',
  FeatOther = 'feat_other',
  ComplexGoals = 'complex_goals',
  ComplexHabits = 'complex_habits',
  ComplexTasks = 'complex_tasks',
  ComplexOther = 'complex_other',
  IssueSync = 'issue_sync',
  IssueHabits = 'issue_habits',
  IssuePerformance = 'issue_performance',
  IssueOther = 'issue_other',
  CompTodoist = 'comp_todoist',
  CompTickTick = 'comp_ticktick',
  CompThings = 'comp_things',
  CompNotion = 'comp_notion',
  CompMarvin = 'comp_marvin',
  CompSunsama = 'comp_sunsama',
  CompAkiflow = 'comp_akiflow',
  CompClickUp = 'comp_clickup',
  CompOther = 'comp_other',
}

export type DeleteAccountSurveyReasonSelectedProps = {
  reason_code: CancelSurveyReasonCode;
};

export type DeleteAccountSurveyDetailSelectedProps = {
  reason_code: CancelSurveyReasonCode;
  detail_code: CancelSurveyDetailCode;
  detail_text?: string;
};

export type DeleteAccountSurveyCompletedProps = {
  reason_code: CancelSurveyReasonCode;
  detail_code?: CancelSurveyDetailCode;
  // Every picked detail, incl. multi-select — detail_code only ever carries a single answer.
  detail_codes?: CancelSurveyDetailCode[];
  detail_text?: string;
  comment?: string;
};

export type CancelSurveyStartedProps = {
  subscription_type: CancelSurveySubscriptionType;
};

export type CancelSurveyReasonSelectedProps =
  DeleteAccountSurveyReasonSelectedProps & CancelSurveyStartedProps;

export type CancelSurveyDetailSelectedProps =
  DeleteAccountSurveyDetailSelectedProps & CancelSurveyStartedProps;

export type CancelSurveyCompletedProps = DeleteAccountSurveyCompletedProps &
  CancelSurveyStartedProps;
